export enum CREATE_SCHEDULE_APPOINTMENTS_TYPES {
  FIRST_APPOINTMENT = 'FIRST_APPOINTMENT',
  NEW_APPOINTMENT = 'NEW_APPOINTMENT',
  RETURN = 'RETURN'
}
